import superagentPromise from 'superagent-promise';
import _superagent from 'superagent';
import axios from 'axios';
import { BACKEND_URL } from './constants/constants';

const superagent = superagentPromise(_superagent, global.Promise);

const API_ROOT = 'https://conduit.productionready.io/api';

const encode = encodeURIComponent;
const responseBody = res => res.body;

const requests = {
  del: url =>
    superagent.del(`${API_ROOT}${url}`).then(responseBody),
  get: url =>
    superagent.get(`${API_ROOT}${url}`).then(responseBody),
  put: (url, body) =>
    superagent.put(`${API_ROOT}${url}`, body).then(responseBody),
  post: (url, body) =>
    superagent.post(`${API_ROOT}${url}`, body).then(responseBody)
};

const testRequests = {
  get: url =>
    superagent.get(`${BACKEND_URL}${url}`).then(responseBody),
  post: (url, body) =>
    superagent.post(`${BACKEND_URL}${url}`, body).then(responseBody)
};

const Auth = {
  current: () =>
    axios.get(`${BACKEND_URL}/user`, { withCredentials: true }).then((res) => res.data),
  login: (email, password) =>
    requests.post('/users/login', { user: { email, password } }),
  register: (username, email, password) =>
    requests.post('/users', { user: { username, email, password } }),
  save: user =>
    requests.put('/user', { user })
};

const Tags = {
  getAll: () => requests.get('/tags')
};

const limit = (count, p) => `limit=${count}&offset=${p ? p * count : 0}`;
const omitSlug = article => Object.assign({}, article, { slug: undefined })
const Articles = {
  all: page =>
    requests.get(`/articles?${limit(10, page)}`),
  byAuthor: ({ author, timestamp, filter, page, haveAnswer }) =>
    axios.get(`${BACKEND_URL}/boards/${author}/questions?timestamp=${timestamp}&filter=${filter}&page=${page}&haveAnswer=${haveAnswer}`, { withCredentials: true }).then((res) => res.data),
  byTag: (tag, page) =>
    requests.get(`/articles?tag=${encode(tag)}&${limit(10, page)}`),
  del: slug =>
    requests.del(`/articles/${slug}`),
  favorite: id =>
    axios.post(`${BACKEND_URL}/questions/${id}/upvotes`, {}, { withCredentials: true }).then((res) => res.data),
  unfavorite: id =>
    axios.post(`${BACKEND_URL}/questions/${id}/downvotes`, {}, { withCredentials: true }).then((res) => res.data),
  favoritedBy: (author, page) =>
    requests.get(`/articles?favorited=${encode(author)}&${limit(5, page)}`),
  feed: () =>
    requests.get('/articles/feed?limit=10&offset=0'),
  get: slug =>
    requests.get(`/articles/${slug}`),
  update: article =>
    requests.put(`/articles/${article.slug}`, { article: omitSlug(article) }),
  create: body =>
    axios.post(`${BACKEND_URL}/questions`, body, { withCredentials: true }).then((res) => res.data),
  answer: body =>
    axios.post(`${BACKEND_URL}/answers`, body, { withCredentials: true }).then((res) => res.data)
};

const Comments = {
  create: (slug, comment) =>
    requests.post(`/articles/${slug}/comments`, { comment }),
  delete: (slug, commentId) =>
    requests.del(`/articles/${slug}/comments/${commentId}`),
  forArticle: slug =>
    requests.get(`/articles/${slug}/comments`)
};

const Profile = {
  follow: username =>
    requests.post(`/profiles/${username}/follow`),
  get: username =>
    testRequests.get(`/boards/${username}`),
  unfollow: username =>
    requests.del(`/profiles/${username}/follow`),
  login: (username, password) =>
    axios.post(`${BACKEND_URL}/auth/login`, { username, password }, { withCredentials: true }).then((res) => res.data),
  check: (username, isPasswordReset) =>
    axios.put(`${BACKEND_URL}/auth/check`, { username, isPasswordReset }, { withCredentials: true }).then((res) => res.data),
  resend: (username) =>
    axios.post(`${BACKEND_URL}/auth/resend`, { username }, { withCredentials: true }).then((res) => res.data),
  verify: (otp, username, password) =>
    axios.post(`${BACKEND_URL}/auth/verify`, { otp, username, password }, { withCredentials: true }).then((res) => res.data),
  setPreferredName: (preferredName) =>
    axios.post(`${BACKEND_URL}/user`, { preferredName }, { withCredentials: true }).then((res) => res.data),
  logout: () => 
    axios.post(`${BACKEND_URL}/auth/logout`, {}, { withCredentials: true }).then((res) => res.data),
};

export default {
  Articles,
  Auth,
  Comments,
  Profile,
  Tags,
};



// WEBPACK FOOTER //
// ./src/agent.js